import React, { useEffect, useState, useRef } from 'react';
import { getValueCookie } from '../services/cookieService';
import axios from "axios";
import Swal from 'sweetalert2';
import server from "../services/Connection/backEndLink";
import { AiOutlineBell } from 'react-icons/ai';

export const NotificationBell = ({ openSO, selectedSO }) => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [prevNotifications, setPrevNotifications] = useState([]);
  const [counter, setCounter] = useState(0);
  // Get company from cookie
  const idCompany = getValueCookie('CompanyId');
  // Interval
  const intervalRef = useRef(null);

  // Get notifications list
  const fetchNotifications = async () => {
    try {
      // All notifications
      let query = `/warehouse/notifications?id_company=${idCompany}`;
      
      // Validate if a SO is selected
      if(selectedSO && selectedSO.OrderNo !== '') {
        const so_number = selectedSO.OrderNo.split('-');
        query = `/warehouse/notifications/by-so?id_company=${idCompany}&order_no=${so_number[0]}`;
      }

      // Get notifications
      await axios.get(`${server.url}${query}`, {}).then(response => {
        const json = response.data;
        // Validate backend response
        if (json && json.status.code === 1) {
          const newNotifications = json.data.data;
          // console.log(newNotifications);
          // Validate if exist a new notification
          const isNew = JSON.stringify(prevNotifications) !== JSON.stringify(newNotifications);
          if (isNew && prevNotifications.length > 0) {
            const sound = new Audio('/sounds/notification.mp3');
            sound.play();
          }

          setNotifications(newNotifications);
          setPrevNotifications(newNotifications);
          setCounter(newNotifications.length);
        }
      }).catch(error => {
        console.log("Error get:");
        console.log(error);
        // Swal.fire({title: `Wait`, text: `${error}`, icon: 'warning', confirmButtonText: 'OK'});
      });
    } catch (err) {
      console.log("Error catch:");
      console.log(err);
      // Swal.fire({title: `Wait`, text: `${err}`, icon: 'warning', confirmButtonText: 'OK'});
    }
  };

  const markAllAsRead = async () => {
    try {
      const query = `/warehouse/notifications/read-all/${idCompany}`;
      
      await axios.post(`${server.url}${query}`, {}).then(response => {
        const json = response.data;
        // Validate backend response
        if (json && json.status.code === 1) {
          setNotifications([]);
          setCounter(0);
          // Show alert
          Swal.fire({title: `Ready`, text: `Notifications were updated`, icon: 'success', confirmButtonText: 'OK'});
        }
      }).catch(error => {
        Swal.fire({title: `Wait`, text: `${error}`, icon: 'warning', confirmButtonText: 'OK'});
      });
    } catch (err) {
      Swal.fire({title: `Wait`, text: `${err}`, icon: 'warning', confirmButtonText: 'OK'});
    }
  };

  const markAsRead = async (soNumber) => {
    try {
      // Validate if a SO is selected
      const query = `/warehouse/notifications/${soNumber}/read/${idCompany}`;
      
      await axios.post(`${server.url}${query}`, {}).then(response => {
        const json = response.data;
        // console.log(json);
        // Validate backend response
        if (json && json.status.code === 1) {
          setNotifications((prev) => prev.filter((n) => n.sales_order_no !== soNumber));
          setCounter((prev) => prev - 1);
          // Show alert
          Swal.fire({title: `Ready`, text: `Notification was updated`, icon: 'success', confirmButtonText: 'OK'});
        }
      }).catch(error => {
        Swal.fire({title: `Wait`, text: `${error}`, icon: 'warning', confirmButtonText: 'OK'});
      });
    } catch (err) {
      Swal.fire({title: `Wait`, text: `${err}`, icon: 'warning', confirmButtonText: 'OK'});
    }
  };

  const confirmOpenSO = async (notification) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Any unsaved changes will be lost if you load this Sales Order.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, load it',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // Load SO
        openSO(notification);
      }
    });
  }

  // Validate if notification window is open
  useEffect(() => {
    var el = document.getElementById('PikingSystem');
    const isVisible = el && window.getComputedStyle(el).display !== 'none';

    if (isVisible) {
      fetchNotifications();
    }
  }, [open]);


  useEffect(() => {
    // Verify if the user is in the section PuckingSystem
    const checkVisibility = () => {
      // Validate if component is displayed
      var el = document.getElementById('PikingSystem');
      const isVisible = el && window.getComputedStyle(el).display !== 'none';

      // Create the loop for get notifications every 5 sec.
      if (isVisible && !intervalRef.current) {
        intervalRef.current = setInterval(() => {
          // if(selectedSO && selectedSO.OrderNo !== '') {
            fetchNotifications();
          // }
        }, 10000);
        console.log('✅ Intervalo iniciado');
      } else if (!isVisible && intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        console.log('🛑 Intervalo detenido');
      }
    };

    // Set observer
    const observer = new MutationObserver(checkVisibility);
    observer.observe(document.body, { attributes: true, childList: true, subtree: true });

    // Initial check
    checkVisibility();

    // Clear the loop for get notifications
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      observer.disconnect();
    };
  }, []);

  return (
    <div style={{ position: 'fixed', bottom: 30, right: 30, zIndex: 9999 }}>
      <button className="btn btn-primary position-relative shadow" onClick={() => setOpen(!open)}>
        <AiOutlineBell size={24} /> 

        {counter > 0 && (
          <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
            {counter}
          </span>
        )}
      </button>

      {open && (
        <div className="card shadow p-3 mt-2" style={{ width: 420 }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            
            {selectedSO && selectedSO.OrderNo !== '' ?  <strong>Notifications</strong> : <strong>All notifications</strong>}
            
            <button className="btn btn-sm btn-outline-secondary" onClick={markAllAsRead}>
              All done
            </button>
          </div>
          <ul className="list-group" style={{height: 400, overflowY: 'scroll'}}>
            {notifications.length === 0 ? (
              <li className="list-group-item text-muted">0 notifications</li>
            ) : (
              notifications.map((n) => (
                <li key={n.id} className="list-group-item d-flex justify-content-between align-items-start">
                  <div>
                    <div className="fw-bold">SO: {n.sales_order_no}</div>
                    <small>{n.change_description}</small>
                    <br />
                    <small>{new Date(n.created_at).toLocaleString()}</small>
                  </div>
                  <div className="ms-2 d-flex flex-column gap-1">
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => confirmOpenSO(n)}
                    >
                      Load
                    </button>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => markAsRead(n.sales_order_no)}
                    >
                      Done
                    </button>
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
